"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowSteps = void 0;
var FlowSteps;
(function (FlowSteps) {
    FlowSteps[FlowSteps["STARTED"] = 0] = "STARTED";
    FlowSteps[FlowSteps["STEP1"] = 1] = "STEP1";
    FlowSteps[FlowSteps["STEP2"] = 2] = "STEP2";
    FlowSteps[FlowSteps["STEP3"] = 3] = "STEP3";
    FlowSteps[FlowSteps["STEP3B"] = 4] = "STEP3B";
    FlowSteps[FlowSteps["STEP4"] = 5] = "STEP4";
    FlowSteps[FlowSteps["SUCCESS"] = 6] = "SUCCESS";
    FlowSteps[FlowSteps["ALREADY_UNLOCKED"] = 7] = "ALREADY_UNLOCKED";
    FlowSteps[FlowSteps["FAILURE"] = 8] = "FAILURE";
    FlowSteps[FlowSteps["STOPPED"] = 9] = "STOPPED";
    FlowSteps[FlowSteps["TIMEOUT"] = 10] = "TIMEOUT";
})(FlowSteps = exports.FlowSteps || (exports.FlowSteps = {}));
